export default "<template>\n  <s-button color=\"primary\" icon=\"Menu\">I'm Button</s-button>\n</template>"